var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Breadcrumb, ScrollView, StackLayout, useActiveThemeVariation } from '@wemogy/reactbase';
import AzureStorageContainerStore from '../../dataLayer/stores/AzureStorageContainerStore';
import AzureStorageEntry from './subComponents/azureStorageEntry/AzureStorageEntry';
var AzureStorageContainerComponent = function (props) {
    var containerUriWithSas = props.containerUriWithSas, onBlobSelected = props.onBlobSelected, emptyRenderer = props.emptyRenderer, loadingRenderer = props.loadingRenderer;
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.azureStorageContainer; });
    var _a = __read(useState(undefined), 2), containerStore = _a[0], setContainerStore = _a[1];
    var handlePathSelected = useCallback(function (subPath) {
        containerStore === null || containerStore === void 0 ? void 0 : containerStore.setActivePrefix(subPath);
    }, [containerStore]);
    useEffect(function () {
        var azureStorageContainer = AzureStorageContainerStore.create({
            containerUriWithSas: containerUriWithSas
        });
        setContainerStore(azureStorageContainer);
    }, [containerUriWithSas]);
    useEffect(function () {
        if (!containerStore) {
            return;
        }
        containerStore.loadMore();
    }, [containerUriWithSas, containerStore === null || containerStore === void 0 ? void 0 : containerStore.activePrefix]);
    if (!containerStore) {
        return null;
    }
    var activeEntries = containerStore.activeEntries;
    // if there is nothing on root level
    if (!activeEntries && !containerStore.activePrefix) {
        return emptyRenderer();
    }
    return (React.createElement(ScrollView, { height: { custom: '50vh' } },
        React.createElement(StackLayout, null,
            React.createElement(Breadcrumb, { path: containerStore.activePrefix, onPathSelected: handlePathSelected }),
            containerStore.isLoading ? loadingRenderer() :
                activeEntries.map(function (entry) { return (React.createElement(AzureStorageEntry, { key: entry.name, entry: entry, azureStorageContainerTheme: activeThemeVariation, marginBottom: true, onBlobSelected: onBlobSelected, containerStore: containerStore })); }))));
};
export default observer(AzureStorageContainerComponent);
//# sourceMappingURL=AzureStorageContainerComponent.js.map